import {openDB, deleteDB} from 'idb';
import {EStructureItem} from '@progress-fe/core';

interface IStructureItemState {
  id: string; // Must be subEntityId or entityId
  entityId: string;
  tabIndex: number;
  entityType: EStructureItem;
  subEntityId: string | null;
}

export const checkpointDbStorage = {
  _initDb: (checkpointId: string) => {
    return openDB(`prog_cp_${checkpointId}`, 1, {
      upgrade(db) {
        if (!db.objectStoreNames.contains('itemStates')) {
          db.createObjectStore('itemStates', {keyPath: 'id', autoIncrement: false});
        }
      }
    });
  },
  _deleteDbs: async (checkpointIds: Array<string>) => {
    const deletePromises: Array<Promise<unknown>> = [];
    checkpointIds.forEach((id) => deletePromises.push(deleteDB(`prog_cp_${id}`)));

    await Promise.allSettled([...deletePromises]);
    console.info(`[Db storage]: Databases deleted: ${checkpointIds.length}`);

    return;
  },
  addOrUpdateItemState: async (checkpointId: string, itemState: IStructureItemState) => {
    try {
      const foundItemState = await checkpointDbStorage.getItemState(checkpointId, itemState.id);

      const db = await checkpointDbStorage._initDb(checkpointId);
      const tx = db.transaction('itemStates', 'readwrite');
      const store = tx.objectStore('itemStates');

      if (!foundItemState) {
        await store.add(itemState);
        console.info(`[Db storage]: Item state added. Tab idx: ${itemState.tabIndex}`);
      } else {
        await store.put(itemState);
        console.info(`[Db storage]: Item state updated. Tab idx: ${itemState.tabIndex}`);
      }

      await tx.done;
    } catch (e) {
      console.warn(`[Db storage]: addOrUpdateItemState error.`, e);
    }
  },
  getItemState: async (checkpointId: string, id: string): Promise<IStructureItemState | null> => {
    const db = await checkpointDbStorage._initDb(checkpointId);
    return db.get('itemStates', id);
  }
};
